import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CardsComponent} from '../cards/cards.component';

@Component({
  selector: 'app-cards-touch',
  templateUrl: './cards-touch.component.html',
  styleUrls: ['./cards-touch.component.css']
})
export class CardsTouchComponent extends CardsComponent implements OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Input() readyForClairvoyant: boolean;
  // @Input() level: number;
  @Output() counterClosedCards = new EventEmitter<number>();

  turnedCards: number[];

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.level || changes.counter) {
      this.generateRandomExercise();
    }
  }

  initValues() {
    super.initValues();
    this.turnedCards = [];
    this.counterClosedCards.emit(0);
  }

  sendCounterClosedCards() {
    this.counterClosedCards.emit(this.turnedCards.length);
  }

  generateMinOpenMinClosed(minOpen: number, minClosed: number) {
    super.generateMinOpenMinClosed(minOpen, 1);
    // The number of cards open has to be initally even:
    while (this.counterOpenCards % 2 !== 0) {
      const rand = Math.floor((Math.random() * this.numberOfTotalCards));
      if (this.isCardVisible[rand] === false) {
        this.isCardVisible[rand] = true;
        this.counterOpenCards ++;
      }
    }
  }

  turnCard(i: number) {
    if ((this.turnedCards.length < 2) && this.turnedCards.indexOf(i) === -1 && !this.readyForClairvoyant) {
      this.isCardVisible[i] = !this.isCardVisible[i];
      this.counterOpenCards --;
      this.turnedCards.push(i);
    }

    this.counterClosedCards.emit(this.turnedCards.length);
  }
}
